/**
 * if a tactic would result in an automatic entry/exit, either via configuration, or an update, etc, this message would be sent.
 * So for example, if a user tried to enter a break price setup long of 100, when the price was 102, this is the message that be sent.
 * {
	"messageType": "alertNotification",
	"notificationId": 1645470327483,
	"notificationDetails": {"errorType":"INVALID_TACTIC_UPDATE","notificationType":"ERROR","tacticName":"CANDLE_MAGNITUDE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "PRICE_FILTERS_TRIGGER_PRICE",
	"statusDetails": {"currentPrice":100.25,"priceSymbol":"XYZ","triggerPrice":100.0},
	"date": "2022-02-21T14:05:28.370-0500",
	"timestamp": "1645470328371"
}

 * @param {*} statusDetails 
 * @returns object with fields:
 * 1) currentPrice: current price that causes filter
 * 2) symbol: symbol of tactic that was related
 * 3) triggerPrice: tactics trigger price
 * 
 */
export function priceFiltersTriggerPriceParser(statusDetails) {
  const parsedObj = {
    currentPrice: null,
    symbol: null,
    triggerPrice: null,
  };
  if (statusDetails) {
    parsedObj.currentPrice = statusDetails.currentPrice ?? null;
    parsedObj.symbol = statusDetails.priceSymbol ?? null;
    parsedObj.triggerPrice = statusDetails.triggerPrice ?? null;
  }
  return parsedObj;
}
